var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.isLoad)?_c('ui-loader'):_vm._e(),_vm._t("default",null,{"is_confirmed":_vm.is_confirmed,"sendCode":function (force) { return _vm.validate(force); }})],2)}
var staticRenderFns = []

export { render, staticRenderFns }